import { Action } from '../core/action'

export const tracker = {
  trackEvent: new Action<
    [
      args: {
        type: string
        action: { type: string; status?: string }
        name: string
        additionalData?: Record<string, any>
      }
    ],
    void
  >(),
} as const
